import { getEventos } from "../services/eventosStore";
import { corDaTurma } from "./coresTurma";

// Tipo da turma (primária/secundária) vem do /usuarios/me; usado para o filtro
// de "extensões acadêmicas" (secundárias) do menu lateral do aluno.
function mapaTipoTurmas(usuario) {
  const map = new Map();
  const turmas = Array.isArray(usuario?.turmas) ? usuario.turmas : [];
  turmas.forEach((t) => {
    if (t?.id) map.set(String(t.id), String(t.tipo || "").toLowerCase());
  });
  return map;
}

function ehSecundaria(tipo) {
  return String(tipo || "").toLowerCase() === "secundario";
}

// Achata os eventos de calendário em ocorrências por (evento × turma do aluno).
// O backend já entrega só os eventos das turmas do aluno, com a turma visível.
// Cada ocorrência vira uma bolinha (dashboard) / card (lateral), com a cor da
// turma escolhida pelo aluno. Filtra extensões (secundárias) conforme o toggle.
export function ocorrenciasCalendario(
  usuario,
  { mostrarSecundarias = false } = {},
) {
  const tipoMap = mapaTipoTurmas(usuario);
  const ocorrencias = [];

  getEventos().forEach((ev) => {
    if (!ev?.calendario || !ev?.data) return;
    const turmas = Array.isArray(ev.turmas) ? ev.turmas : [];

    turmas.forEach((turma) => {
      if (!turma?.id) return;
      const secundaria = ehSecundaria(tipoMap.get(String(turma.id)));
      if (secundaria && !mostrarSecundarias) return;

      ocorrencias.push({
        eventoId: ev.id,
        titulo: ev.titulo,
        descricao: ev.descricao,
        criadoPorNome: ev.criadoPorNome,
        data: ev.data, // "YYYY-MM-DD"
        turmaId: turma.id,
        turmaNome: turma.complemento
          ? `${turma.nome} - ${turma.complemento}`
          : turma.nome,
        cor: corDaTurma(turma.id),
        secundaria,
        vistoCalendario: !!turma.vistoCalendario,
        confirmacaoPresenca: !!ev.confirmacaoPresenca,
        presencaConfirmadaEm: turma.presencaConfirmadaEm || null,
        ultimaAtualizacao: ev.ultimaAtualizacao,
      });
    });
  });

  return ocorrencias;
}
